import React, { memo } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-280">
      <div className="max-w-3xl mx-auto" data-id="element-281">
        <div ref={fadeIn.ref} className={`space-y-8 text-lg md:text-xl ${fadeIn.className}`} data-id="element-282">
          <div className="text-center mb-12" data-id="element-283">
            <h2 className="text-3xl md:text-4xl font-black text-yellow-400 mb-6" data-id="element-284">
              💔 ¿Cuántos días más vas a pasar sin saber cómo ayudar?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-285">
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-286">
              <div className="text-4xl mb-4" data-id="element-287">🌋</div>
              <p className="text-gray-300 font-medium" data-id="element-288">
                Tu hijo explota o se bloquea y no sabés qué hacer en ese momento
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-289">
              <div className="text-4xl mb-4" data-id="element-290">💥</div>
              <p className="text-gray-300 font-medium" data-id="element-291">
                Querés hablar con él/ella pero cada conversación termina en
                pelea o silencio
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-292">
              <div className="text-4xl mb-4" data-id="element-293">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-294">
                Ves que las redes lo/la afectan pero no tenés cómo abordarlo sin
                que se ponga defensivo/a
              </p>
            </div>
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-295">
              <div className="text-4xl mb-4" data-id="element-296">😰</div>
              <p className="text-gray-300 font-medium" data-id="element-297">
                La ansiedad y el estrés escolar están ahí y no tenés un
                protocolo claro para ayudar
              </p>
            </div>
          </div>

          <div className="text-center mt-12 space-y-4" data-id="element-298">
            <p className="text-2xl font-bold text-white" data-id="element-299">
              No es falta de amor. Es falta de herramientas. ❤️
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-300">
              Querés acompañar a tu hijo o a tus alumnos. Pero nadie te enseñó
              cómo.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-4" data-id="element-301">
              Nadie te enseñó cómo hablar de emociones sin que se cierren, cómo
              manejar una crisis sin explotar vos también, o cómo ayudarlos a
              tomar decisiones sin que sientan que los controlás.
            </p>
          </div>

          <div className="bg-gray-900 p-8 rounded-xl border border-yellow-500 mt-12 shadow-2xl" data-id="element-302">
            <div className="space-y-6 text-gray-300" data-id="element-303">
              <p className="flex items-start gap-3" data-id="element-304">
                <span className="text-2xl" data-id="element-305">🔑</span>
                <span className="font-bold text-white" data-id="element-306">
                  Lo que necesitás es un sistema completo de gestión emocional
                  adolescente, listo para usar desde el primer día.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-307">
                <span className="text-2xl" data-id="element-308">📔</span>
                <span data-id="element-309">
                  Con Mi Espacio Interior vas a tener 6 tomos + 6 bonos con +500
                  páginas de herramientas, ejercicios y guías.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-310">
                <span className="text-2xl" data-id="element-311">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-312">
                  ¿Y si hoy fuera el último día que pasás sin saber cómo ayudar?
                  💙
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}